import _ from 'lodash'

export default {
  namespaced: true,
  getters: {
    activeTags (state, getters, rootState) {
      const routeName = rootState.route.name

      if (routeName === 'masterplan') {
        return _.sortBy(rootState.property.livingOptions, tag => {
          tag.type = 'tag'
          tag.to = `/category/${rootState.route.params.categoryId}/masterplan/lo/${tag.id}`
          return tag.marker.x
        })
      }

      if (routeName === 'masterplan-livingoption' && getters.activeLivingOption) {
        return _.sortBy(getters.activeLivingOption.subsectionGroups, tag => {
          tag.type = 'tag'
          tag.to = `/category/${rootState.route.params.categoryId}/masterplan/sg/${tag.id}`
          return tag.marker.x
        })
      }

      if (routeName === 'masterplan-subsectiongroup' && getters.activeSubsectionGroup) {
        return _.sortBy(getters.activeSubsectionGroup.subsections, tag => {
          tag.type = 'tag'
          tag.to = `/category/${rootState.route.params.categoryId}/masterplan/s/${tag.id}`
          return tag.marker.x
        })
      }

      if ((routeName === 'masterplan-subsection' || routeName === 'masterplan-property') && getters.activeSubsection) {
        return _.sortBy(getters.activeSubsection.properties, tag => {
          tag.type = 'dot'
          tag.to = `/category/${rootState.route.params.categoryId}/masterplan/s/${getters.activeSubsection._id}/${tag.id}`
          return tag.marker.x
        })
      }
    },    

    activeLivingOption: (state, getters, rootState) => {
      const routeName = rootState.route.name
      const livingOptionId = rootState.route.params.livingOptionId

      if (routeName.includes('masterplan') && livingOptionId) {
        return _.find(rootState.property.livingOptions, livingOption => {
          return livingOption._id === livingOptionId
        })
      } else {
        return null
      }
    },    

    activeSubsectionGroup: (state, getters, rootState) => {
      const routeName = rootState.route.name
      const subsectionGroupId = rootState.route.params.subsectionGroupId

      if (routeName.includes('masterplan') && subsectionGroupId) {
        return _.find(rootState.property.subsectionGroups, subsectionGroup => {
          return subsectionGroup._id === subsectionGroupId
        })
      } else {
        return null
      }
    },

    activeSubsection: (state, getters, rootState) => {
      const routeName = rootState.route.name
      const subsectionId = rootState.route.params.subsectionId

      if (routeName.includes('masterplan') && subsectionId) {
        return _.find(rootState.property.subsections, subsection => {
          return subsection._id === subsectionId
        })
      } else {
        return null
      }
    },

    activeProperty: (state, getters, rootState) => {
      const routeName = rootState.route.name
      const propertyId = rootState.route.params.propertyId

      if (routeName.includes('masterplan') && propertyId) {
        return _.find(rootState.property.properties, property => {
          return property._id === propertyId
        })
      } else {
        return null
      }
    },
  }
}